/*
 * @Descripttion: 通用函数
 * @version:
 * @Author: YOYO [792611446@qq.com]
 * @Date: 2022-12-14 09:19:20
 * @LastEditors: YOYO [792611446@qq.com]
 * @LastEditTime: 2024-03-21 13:53:27
 */
/**
 * @description                       将函数转成防抖动函数
 * @param  {Function}                 需要转成防抖动函数的函数
 * @param  {number}                   延迟时间（毫秒数）
 * @param  {boolean}                  是否执行第一次
 * @return {undefined}                无返回值
 */
export function debounce (fn, delay = 600, runFirstFn = true) {
  let timer = null

  return function (...rest) {
    // 清除定时器
    clearTimeout(timer)

    if (runFirstFn) {
      fn.apply(this, rest)
      runFirstFn = false
      return
    }

    // 设置定时器
    timer = setTimeout(fn.bind(this, ...rest), delay)
  }
}

// 去除前后空格
export function trim (str) {
  var result = str.replace(/(^\s*)|(\s*$)/g, '')
  return result
}

export const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  // eslint-disable-next-line
  // return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')

  return [year, initTime(month), initTime(day)].join('-') + ' ' + [hour, minute, second].join(':')
}

function initTime (a) {
  a += ''
  return a[1] ? a : `0${a[0]}`
}
export function textPassword (password, self) {
  // 必须包含大小写字母、数字、特殊字符
  const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=_！]).+$/
  //不能相同字符（如111、aaa）连续3位或3位以上
  const regex1 = /(\w)*(\w)\2{2}(\w)*/g

  if (password.length < 8) {
    self.$message({ type: 'warning', message: '密码长度至少8位！' })
    return false
  } else if (!regex.test(password)) {
    self.$message({ type: 'warning', message: '密码必须包含大小写字母、数字、特殊字符[!@#$%^&+=_]' })
    return false
  } else if (regex1.test(password)) {
    self.$message({ type: 'warning', message: '密码不能含有相同字符（例如111、aaa）连续3位或3位以上' })
    return false
  } else {
    // 不能连续字符（如123、abc）连续3位或3位以上
    for (let i = 1; i < password.length - 1; i++) {
      let firstIndex = password[i - 1].charCodeAt()
      let secondIndex = password[i].charCodeAt()
      let thirdIndex = password[i + 1].charCodeAt()
      if ((thirdIndex - secondIndex == 1) && (secondIndex - firstIndex == 1)) {
        self.$message({ type: 'warning', message: '密码禁止设置递增的字母或数字（例如abc,123）连续3位或3位以上!' })
        return false
      }
    }

    if (checkKeyboardContinuousChar(password)) {
      self.$message({ type: 'warning', message: '密码不能含有标准键相邻按键组合（例如ASDFG,QWERTY）' })
      return false
    } else {
      return true
    }
  }
}

/**
 * 判断字符串是否键盘三连（横着、竖着）
 * @param {String} str
 * @returns boolean 是否满足键盘3连键
 */
export function checkKeyboardContinuousChar(password) {
  const c1 = [
    ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '+'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '{', '}', '|'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ':', '"'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm', '<', '>', '?']
  ]
  const c2 = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '='],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']', '\\'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', '\''],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/']
  ]
  let str = password.toLowerCase().split('')
  // 获取坐标位置
  const y = []
  const x = []
  for (let c = 0; c < str.length; c++) {
    y[c] = 0// 当做~`键处理
    x[c] = -1
    for (let i = 0; i < c1.length; i++) {
      for (let j = 0; j < c1[i].length; j++) {
        if (str[c] == c1[i][j]) {
          y[c] = i
          x[c] = j
        }
      }
    }
    if (x[c] != -1) continue
    for (let i = 0; i < c2.length; i++) {
      for (let j = 0; j < c2[i].length; j++) {
        if (str[c] == c2[i][j]) {
          y[c] = i
          x[c] = j
        }
      }
    }
  }
  // 匹配坐标连线
  for (let c = 1; c < str.length - 1; c++) {
    // 横着同一行
    if (y[c - 1] == y[c] && y[c] == y[c + 1]) {
      // 从左往右或者从右往左一排
      if ((x[c - 1] + 1 == x[c] && x[c] + 1 == x[c + 1]) || (x[c + 1] + 1 == x[c] && x[c] + 1 == x[c - 1])) {
        return true
      }
    }
  }
  return false
}
